export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0B192C" />
    <circle cx="32" cy="32" r="19" fill="none" stroke="#C87D55" strokeWidth="3" />
    <path d="M20 38 L26 24 L32 34 L38 24 L44 38" fill="none" stroke="#F4EDE3" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 44 Q24.5 40 32 44 T47 44" fill="none" stroke="#C87D55" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light }) => (
  <a href="#top" data-testid="header-logo" className="flex items-center gap-3">
    <LogoMark />
    <span className={`font-display text-xl tracking-tight ${light ? "text-[#F4EDE3]" : "text-[#0B192C]"}`}>
      Marine<span className="italic text-[#C87D55]">OS</span>
      <sup className="ml-0.5 text-[10px] font-body">™</sup>
    </span>
  </a>
);
